export default __webpack_public_path__ + "static/media/react.44319306.png";